import Repository from '../../Repository';

const url = '/locker-room/stats';

export default {
    getStatsBetween(dateFrom, dateTo) {
        return Repository.get(`${url}/training-completions?from=${dateFrom}&to=${dateTo}`);
    },
    getCounters(dateFrom, dateTo) {
        return Repository.get(`${url}/training-counters?from=${dateFrom}&to=${dateTo}`)
    }
}
